import React from "react"
import "./App.css"
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/js/bootstrap.min.js';
import { StaffLogin, Dashboard, DashboardLayout, Layout, Homedesign, TextBlock, FullWidthBanners, Carousels } from "./Components"
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from "./Utils/ProtectedRoute"
import Logout from "./Utils/Logout";
import {
  NotFound, ProfilePage, Users, UsersAdd, AuditionsList, Verified, VerifiedList, VerifiedInfo, HCCOrder, RazorpayList, RequirementsList,
  AuditionRequirement,
  AudiInterests,
  AuditionApplications,
  Chatreports,
  VerifiedWrapper,
  CallbackRequests,
  AdvertisingCampaigns,
  AdvertisingCampaignDetail,
  ReportsInbox,
  PostReviewQueue,
  InviteAnalytics,
  ProductInsights,
  CastingPackagesList,
  SalesCrmDashboard,
  SalesLeadsList,
  SalesOpportunityDetail,
  SalesCrmAdmin,
  SalesManualLead,
} from "./Pages"
import { MessagesPage } from "./Pages/MessagesPage";
import { Calendar } from "antd";
// import ChartTable from "./Components/DashboardLayout/Chart.js"
import { AdminDashboard } from "./Pages/AdminDashboard";
import { AuditionInfo } from "./Pages/AuditionInfo";
import ChatTable from "./Pages/chattable";
import { ScrollProvider } from "./Utils/ScrollContext";
import { SearchProducts } from "./Pages/SearchProducts";
import { SearchProvider } from "./Utils/SearchContext";
function App() {
  return (
    <Router>
      <SearchProvider>
      <ScrollProvider>
      <Routes>
        <Route path='/' element={<StaffLogin />} />
        <Route path="" element={<ProtectedRoute />} >
        <Route path="" element={<DashboardLayout/>}>
          <Route path="/logout" element={<Logout />} />
          <Route path='/s' element={<SearchProducts />} />
          <Route path="/:url" element={<Layout />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/dashboard/users" element={<Users />} />
          <Route path="/dashboard/users/:id/edit" element={<ProfilePage />} />
          <Route path="/dashboard/masters/Auditions" element={<AuditionsList />} />
          <Route path="/dashboard/masters/verified" element={<VerifiedList />} />
          <Route path="/dashboard/masters/Auditions/:id/edit" element={<AuditionInfo />} />
          <Route path="/dashboard/masters/verified/:id/edit" element={<VerifiedInfo />} />
          <Route path="/dashboard/masters/orders" element={<HCCOrder />} />
          <Route path="/dashboard/masters/razor-pays" element={<RazorpayList />} />
          <Route path="/dashboard/masters/Audition-requirements" element={<RequirementsList />} />
          <Route path="/dashboard/masters/Audition-requirements/:id/edit" element={<AuditionRequirement />} />
          <Route path="/dashboard/masters/Audition-interests" element={<AudiInterests />} />
          <Route path="/dashboard/masters/Audition-applications/:id/" element={<AuditionApplications />} />
          <Route path="/dashboard/masters/chat-reports" element={<Chatreports />} />
          <Route path="/dashboard/masters/chat-table" element={<ChatTable />} />
          <Route path="/dashboard/masters/callback-requests" element={<CallbackRequests />} />
          <Route path="/dashboard/masters/reports-inbox" element={<ReportsInbox />} />
          <Route path="/dashboard/masters/post-review" element={<PostReviewQueue />} />
          <Route path="/dashboard/masters/invite-analytics" element={<InviteAnalytics />} />
          <Route path="/dashboard/masters/product-insights" element={<ProductInsights />} />
          <Route path="/dashboard/masters/casting-packages" element={<CastingPackagesList />} />
          <Route path="/dashboard/sales-crm" element={<SalesCrmDashboard />} />
          <Route path="/dashboard/sales-crm/leads" element={<SalesLeadsList />} />
          <Route path="/dashboard/sales-crm/leads/:id" element={<SalesOpportunityDetail />} />
          <Route path="/dashboard/sales-crm/admin" element={<SalesCrmAdmin />} />
          <Route path="/dashboard/sales-crm/manual" element={<SalesManualLead />} />
          <Route path="/dashboard/advertising/campaigns" element={<AdvertisingCampaigns />} />
          <Route path="/dashboard/advertising/campaigns/:id" element={<AdvertisingCampaignDetail />} />
          <Route path="/messages/:hccId" element={<MessagesPage />} />
          </Route>
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      </ScrollProvider>
      </SearchProvider>
    </Router>
  );
}

export default App;
